import Button from "components/button";
import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import { MdModeEditOutline } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewModal from "./ViewModal";
import EditContainers from "./EditContainers";

function CardContainers({ containerDetails, refreshList }) {
  const [editOpen, setEditOpen] = useState(false);
  const { container: containerPharm = {} } = useSelector(
    (state) => state.auth.permissions || {}
  );
  const containerDetailsArray = useMemo(() => {
    if (!containerDetails) return [];

    return [
      {
        label: "Departure Port",
        value: containerDetails.departurePort || "N/A",
      },
      { label: "Arrival Port", value: containerDetails.arrivalPort || "N/A" },
      {
        label: "Departure Date",
        value: containerDetails.departureTimeDate || "N/A",
      },

      {
        label: "ETA",
        value: containerDetails.eta || "N/A",
      },
      { label: "Status", value: containerDetails?.status?.name || "N/A" },
    ];
  }, [containerDetails]);
  return (
    <Card extra={"w-full h-full p-3"}>
      {/* Header */}

      <div className="mb-8 mt-2 flex w-full items-center justify-between">
        <h4 className="px-2 text-lg font-bold text-navy-700 dark:text-white">
          Container #{containerDetails.containerNo}
        </h4>

        <CardMenu
          items={[
            containerPharm?.edit && {
              label: "Edit",
              icon: <MdModeEditOutline />,
              onClick: () => setEditOpen(true),
            },
            // containerPharm?.delete && {
              // label: "Delete",
              // icon: <FaTrashAlt className="h-4 w-4" />,
            // },
          ].filter(Boolean)}
        />
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 gap-2">
        {containerDetailsArray?.map((item, index) => (
          <div key={index} className="flex items-start justify-between px-3 ">
            <p className="text-sm text-gray-600">{item.label}</p>
            <p className="text-sm font-medium text-navy-700 dark:text-white">
              {item.value}
            </p>
          </div>
        ))}
        <div className="flex items-start justify-center gap-3 ">
          {containerPharm?.isDetail && (
            <Link to={`/containers/${containerDetails?._id}`}>
              <Button variant="outline" className="py-1 text-sm">
                Details
              </Button>
            </Link>
          )}
          {containerPharm?.isView && (
            <ViewModal containerDetails={containerDetails} />
          )}
        </div>
      </div>

      <EditContainers
        containerDetails={containerDetails}
        refreshList={refreshList}
        isOpen={editOpen}
        onClose={() => setEditOpen(false)}
      />
    </Card>
  );
}

export default CardContainers;
